import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Tracks browser online/offline state via `navigator.onLine` plus the
 * `online`/`offline` window events. Listeners are attached on mount and
 * removed on unmount, so this must be used from within a component setup.
 */
export function useOnlineStatus() {
  const isOnline = ref(typeof navigator !== 'undefined' ? navigator.onLine : true)

  function setOnline() {
    isOnline.value = true
  }

  function setOffline() {
    isOnline.value = false
  }

  onMounted(() => {
    window.addEventListener('online', setOnline)
    window.addEventListener('offline', setOffline)
  })

  onUnmounted(() => {
    window.removeEventListener('online', setOnline)
    window.removeEventListener('offline', setOffline)
  })

  return { isOnline }
}
